import { render, staticRenderFns } from "./TripWarningList.vue?vue&type=template&id=8fa31686&scoped=true"
import script from "./TripWarningList.vue?vue&type=script&lang=js"
export * from "./TripWarningList.vue?vue&type=script&lang=js"
import style0 from "./TripWarningList.vue?vue&type=style&index=0&id=8fa31686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa31686",
  null
  
)

export default component.exports